(function () {
  'use strict';
  const availability = 'filter.v.availability';
  const handles = new Set(['all', 'suplementos', 'cuidado-personal', 'gourmet', 'hogar']);
  const previewKeys = ['preview_theme_id', '_ab', '_fd', '_sc'];

  function collectionUrl(href, base) {
    if (!href || href.startsWith('#')) return null;
    try {
      const current = new URL(base);
      const target = new URL(href, current);
      const match = target.pathname.match(/^\/(?:[a-z]{2,3}(?:-[a-z]{2,4})?\/)?collections\/([^/]+)\/?$/i);
      if (target.origin !== current.origin || !match || !handles.has(match[1]) || target.searchParams.has('view')) return null;
      return target;
    } catch (_) { return null; }
  }

  function preservePreview(target, base) {
    const current = new URL(base);
    previewKeys.forEach(key => {
      if (!target.searchParams.has(key) && current.searchParams.has(key)) {
        target.searchParams.set(key, current.searchParams.get(key));
      }
    });
    return target;
  }

  function defaultUrl(href, base, eligible) {
    const target = eligible && collectionUrl(href, base);
    if (!target || target.searchParams.has(availability)) return null;
    target.searchParams.set(availability, '1');
    target.searchParams.delete('page');
    return preservePreview(target, base).href;
  }

  function choiceUrl(href, base, value) {
    const target = collectionUrl(href, base);
    if (!target || !['1', '0,1'].includes(value)) return null;
    target.searchParams.set(availability, value);
    target.searchParams.delete('page');
    if (!target.hash) target.hash = new URL(base).hash;
    return preservePreview(target, base).href;
  }

  // Tests exercise URL policy only, not Shopify rendering or vendor AJAX behavior.
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { defaultUrl, choiceUrl };
    return;
  }
  if (typeof document === 'undefined') return;

  const nativeRegion = '[data-ntajax-container], #FacetFiltersForm, #t4s-filter-hidden, [data-filter-area]';
  const availabilityRemoval = '[data-marturi-stock-clear], #FacetFiltersForm a[aria-current="true"], #t4s-filter-hidden a[aria-current="true"]';
  const originals = new WeakMap();

  function enhance(anchor) {
    if (!anchor || anchor.hasAttribute('download') || (anchor.target && anchor.target !== '_self')) return;
    const marker = document.querySelector('[data-marturi-stock]');
    const original = originals.get(anchor) || anchor.getAttribute('href');
    let next = null;
    if (marker && anchor.matches('[data-marturi-stock-choice]')) {
      next = choiceUrl(original, location.href, anchor.dataset.marturiStockChoice);
    } else if (marker && anchor.matches(availabilityRemoval)) {
      const target = collectionUrl(original, location.href);
      // Removing the final native availability value means intentionally viewing all.
      if (target && !target.searchParams.has(availability)) next = choiceUrl(original, location.href, '0,1');
    } else if (!anchor.closest(nativeRegion)) {
      next = defaultUrl(original, location.href, true);
    }
    if (next && next !== anchor.href) {
      originals.set(anchor, original);
      anchor.href = next;
    }
  }

  function refreshLinks() {
    document.querySelectorAll('a[href*="/collections/"]').forEach(enhance);
  }

  function start() {
    const marker = document.querySelector('[data-marturi-stock]');
    const next = defaultUrl(location.href, location.href, Boolean(marker));
    if (next) { location.replace(next); return; }
    refreshLinks();
    // Capture runs before native delegated facet handlers read the anchor URL.
    document.addEventListener('click', event => {
      const anchor = event.target instanceof Element ? event.target.closest('a[href]') : null;
      enhance(anchor);
    }, true);
    let scheduled = false;
    new MutationObserver(records => {
      if (scheduled || !records.some(record => record.addedNodes.length)) return;
      scheduled = true;
      requestAnimationFrame(() => { scheduled = false; refreshLinks(); });
    }).observe(document.body, { childList: true, subtree: true });
    // Never rerun the bare-URL default after AJAX, popstate or BFCache restoration.
    window.addEventListener('pageshow', refreshLinks);
    window.addEventListener('popstate', refreshLinks);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
